module.exports = __webpack_public_path__ + "img/entry.01c7bd3.png";